Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-add-ons', function (envelope) {
        var $context = envelope.message.data.context,
            $control = $('.x-product-details-add-ons', $context);

        if ($control.length < 1)
            return;

        $.each($control, function (i, control) {

            $(".js-checkbox-add-on", control).click(function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    e.stopPropagation();

                    return;
                }
            });

            $(".js-checkbox-add-on", control).change(function () {
                if ($(this).is(':checked')) {
                    $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');
                } else {
                    if ($(".js-checkbox-add-on:checked", $control).length < 1 && ($(".js-select-add-on option:selected", $control).val() == "" || typeof $(".js-select-add-on option:selected", $control).val() === "undefined"))
                        $('.x-product-details-ajax-buttons .js-add-to-cart', $context).removeClass('has-add-on-products');
                }
            });

            $(".js-select-add-on", control).change(function () {

                var option = $(this).find("option:selected");

                if (option.val() != "") {
                    $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');
                } else {
                    if ($(".js-checkbox-add-on:checked", $control).length < 1 && ($(".js-select-add-on option:selected", $control).val() == "" || typeof $(".js-select-add-on option:selected", $control).val() === "undefined"))
                        $('.x-product-details-ajax-buttons .js-add-to-cart', $context).removeClass('has-add-on-products');
                }
            });

            //check addon after sku change
            if ($(".js-checkbox-add-on", control).is(":checked"))
                $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');

            if ($(".js-select-add-on", control).find("option:selected").length > 0 && $(".js-select-add-on", control).find("option:selected").val() != "")
                $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');

            //init Quick Buy in order to support
            //addons with dimensions
            initAddOnsList();

        });

        function initAddOnsList() {

            var $addOnsPl = $('.x-product-list-add-ons');

            if ($addOnsPl.length < 1) return;

            $addOnsPl.each(function () {

                var $wrapper = $(this),
                    wrapper = $wrapper.get(0),
                    hasQuickbuy = $wrapper.data('quickbuy') === true;

                if (!hasQuickbuy || !window.jsonArr) return;

                //get configuration
                var $configuration = $('.configuration', $wrapper);
                var configuration = $configuration.text();

                //call service to get product list model
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetCurrentPage(wrapper, configuration, 'productList'));

                //on success init quick buy
                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetCurrentPageSuccess, wrapper, function (envelope) {

                    if (envelope.message.data.list.list != wrapper) return;

                    var model = envelope.message.data.model;

                    Vendd.Quickbuy.addToQuickbuyList(model);

                    var $box = $('.x-pd-addons-box', $wrapper);

                    $.each($box, function (i, box) {
                        initQuickBuy($(box));
                    });

                });
            });
        };

        function initQuickBuy($wrapper) {

            var wrapper = $wrapper.get(0);
            var userModel = {}, showPriceWithoutVat = false;

            wrapper.productId = $wrapper.data('productid');
            wrapper.defaultColor = $wrapper.data('default-colorid');

            wrapper.selectedColor = null, wrapper.selectedSize = null, wrapper.selectedDim3 = null;

            var state = Vendd.Quickbuy.initState(wrapper.productId, wrapper.defaultColor);

            if (state == undefined) return; 

            wrapper.model = state;
            wrapper.dimensionWidget = $('.x-dimensions-widget', $wrapper);
            wrapper.partial = $wrapper.data('partial') || "productDimensions_A";
            wrapper.fixedPrices = $wrapper.data('fixed-prices');
            wrapper.priceElement = $('.current-price', $wrapper);
            wrapper.imageCont = $('.image-container', $wrapper);
            wrapper.image = $('.image-container', $wrapper).find('img');

            if (!state.HasColors && !state.HasSizes && !state.HasDim3) {
                $wrapper.siblings('.checkbox-wrapper').addClass('disabled').find('.js-checkbox-add-on').addClass('disabled');
                return;
            }

            //check for new state
            if ($wrapper.data('color-id')) { 
                state.createNewColorState = true;
                wrapper.selectedColor = $wrapper.data('color-id');
            }
            if ($wrapper.data('size-id')) {
                state.createNewSizeState = true;
                wrapper.selectedSize = $wrapper.data('size-id');
            }
            if ($wrapper.data('dim3-id')) {
                state.createNewDim3State = true;
                wrapper.selectedDim3 = $wrapper.data('dim3-id');
            }

            //create new state
            if (state.createNewColorState) {
                Vendd.Quickbuy.createNewState(wrapper, wrapper.selectedColor ? wrapper.selectedColor : state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'color');
            }
            if (state.createNewSizeState) {
                Vendd.Quickbuy.createNewState(wrapper, wrapper.selectedSize ? wrapper.selectedSize : state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'size');
            }
            if (state.createNewDim3State) {
                Vendd.Quickbuy.createNewState(wrapper, wrapper.selectedDim3 ? wrapper.selectedDim3 : state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'dim3');
            }

            wrapper.GetUserModel = function () {
                userModel = Vendd.User && Vendd.User.GetClientModel();

                if (userModel) {
                    userModel = { ...userModel, ...{ ClientEnhancedModel: window.LhApp.ClientEnhancedModel } }; // model to be expanded from page html (window.LhApp = window.LhApp || {}; window.LhApp.ClientEnhancedModel = window.LhApp.ClientEnhancedModel || {};
                    showPriceWithoutVat = userModel.ShowPriceWithoutVat;
                }
            };

            wrapper.UpdateBoxData = function (type, imgSrc) {
                var $wrapper = $(this);

                if (type === 'color' && typeof imgSrc != 'undefined') {
                    wrapper.image.attr('src', imgSrc);
                    wrapper.imageCont.removeClass('hidden');
                }

                var selectedColorId = (typeof wrapper.SelectedColorId != 'undefined') ? wrapper.SelectedColorId : null;
                var selectedSizeId = (typeof wrapper.SelectedSizeId != 'undefined') ? wrapper.SelectedSizeId : null;
                var selectedDim3Id = (typeof wrapper.SelectedDim3Id != 'undefined') ? wrapper.SelectedDim3Id : null;

                if ((wrapper.model.HasColors && !state.HasSingleColor && selectedColorId == null)
                    || (wrapper.model.HasSizes && !state.HasSingleSize && selectedSizeId == null)
                    || (wrapper.model.HasDim3 && !state.HasSingleDim3 && selectedDim3Id == null))
                {
                    $wrapper.siblings('.checkbox-wrapper').addClass('disabled').find('.js-checkbox-add-on').addClass('disabled').prop("checked", false);
                    return;
                }

                var selectedSku = Vendd.Quickbuy.GetSkuData(wrapper, wrapper.productId, wrapper.defaultColor, selectedColorId, selectedSizeId, selectedDim3Id);

                if (selectedSku !== null && typeof selectedSku !== "undefined") {
                    var skuData = selectedSku.SkuData;

                    $wrapper.data('variantid', skuData.SkuId);
                    $wrapper.siblings('.checkbox-wrapper').find('.js-checkbox-add-on').data('sku-id', skuData.SkuId);

                    if (!skuData.CanBuy) {
                        $wrapper.siblings('.checkbox-wrapper').addClass('disabled').find('.js-checkbox-add-on').addClass('disabled');
                    } else {
                        $wrapper.siblings('.checkbox-wrapper').removeClass('disabled').find('.js-checkbox-add-on').removeClass('disabled');
                    }

                    //manipulate prices
                    if (!wrapper.fixedPrices) {
                        if ($enableFormatPrices) {
                            if (!wrapper.priceElement.hasClass('price-formatted')) {
                                wrapper.priceElement.addClass('price-formatted');
                            }
                            wrapper.priceElement.html(formatPrice(skuData.UnitPrice));
                        } else {
                            wrapper.priceElement.text(skuData.UnitPrice);
                        }
                    }

                }
            };

            $wrapper.on('click', '.js-dimensions li', function (e) {

                var $this = $(this), id, type, name, $wrap, wrapper, productId, defaultColor, imgSrc,
                    isColorList, isSizeList, isDim3List, $color, $size;

                if ($this.hasClass('selected') || $this.hasClass('disabled'))
                    return;

                id = $this.data('id');
                name = $this.data('name');
                type = $this.closest('.js-dimensions').data('type');

                isColorList = ($this.parent().hasClass('colors-list')) ? true : false;
                isSizeList = ($this.parent().hasClass('sizes-list')) ? true : false;
                isDim3List = ($this.parent().hasClass('dim3-list')) ? true : false;

                if (isColorList) imgSrc = $this.data('image');

                $wrap = $this.closest('.x-pd-addons-box');
                wrapper = $wrap.get(0);
                productId = $wrap.data('productid');
                defaultColor = $wrap.data('default-colorid');

                $this.addClass('selected').siblings().removeClass('selected');

                if (id === undefined) return;

                var state = Vendd.Quickbuy.createNewState(wrapper, id, productId, defaultColor, type);
                Vendd.Quickbuy.Update(wrapper.dimensionWidget, state, wrapper.partial);

                if (isColorList) {
                    wrapper.UpdateBoxData("color", imgSrc);
                    $wrap.attr('data-color', name);
                    $wrap.attr('data-color-id', id);
                } else if (isSizeList) {
                    wrapper.UpdateBoxData("size", imgSrc);
                    $wrap.attr('data-size', name);
                    $wrap.attr('data-size-id', id);
                } else if (isDim3List) {
                    wrapper.UpdateBoxData("dim3", imgSrc);
                    $wrap.attr('data-dim3', name);
                    $wrap.attr('data-dim3-id', id);
                }

                colorSelectorCallback = false;
            });

            $wrapper.on('click', '.js-dropdown-btn', function (e) {
                var $this = $(this);

                if ($this.hasClass('disabled')) return;

                if ($this.hasClass('expanded')) {
                    $this.removeClass('expanded');
                } else {
                    $('.js-dropdown-btn.expanded').removeClass('expanded');
                    $this.addClass('expanded');
                }
            });

            $(document).click(function (event) {
                if (!$(event.target).closest('.js-dropdown-btn').length &&
                    !$(event.target).is('.js-dropdown-btn')) {

                    $('.js-dropdown-btn').removeClass("expanded");
                }
            });

            Vendd.Quickbuy.Update(wrapper.dimensionWidget, state, wrapper.partial);

            //get selected dimension image
            var selectedImg = $wrapper.find('.js-dimensions > li.selected').data('image');

            wrapper.UpdateBoxData("color", selectedImg);

            $wrapper.addClass('x-initialized');
        }

    });
});
